<template>
    <div class="icon-wrap">
        <span
            v-if="!tab.customIcon"
            class="material-icons"
            :class="{active: isActive}"
            @click="$emit('open-tab', tab.id)"
        >
            {{tab.icon}}
        </span>
        <span
            v-else
            :class="{active: isActive}"
            class="custom-icons"
            @click="$emit('open-tab', tab.id)"
        >
            <entity-icon v-if="showEntitiesIcon" />
            <feature-icon v-else-if="showFeatureIcon" />
        </span>
    </div>
</template>

<script>
import FeatureIcon from '@/assets/feature-icon'
import EntityIcon from '@/assets/entity-icon'

export default {
  components: {
    EntityIcon,
    FeatureIcon
  },

  props: {
    tab: Object,
    activeTab: Object,
    sidebarIsOpen: Boolean
  },

  computed: {
    isActive () {
      return this.activeTab.id === this.tab.id && this.sidebarIsOpen
    },

    showFeatureIcon () {
      return this.tab.customIcon && this.tab.icon === 'features'
    },

    showEntitiesIcon () {
      return this.tab.customIcon && this.tab.icon === 'entities'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;

    .material-icons, .custom-icons {
        font-size: 20px;
        color: $or-grey-dark;

        &:hover {
            color: darken($or-grey-dark, 10%);
            cursor: pointer;
            transition: all .2s ease;
        }

        &.active {
            color: $or-black-blue;
        }
    }
    .custom-icons {
        height: $sp-3;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
